<div
  [id]="id"
  class="notification-alert madero-style alert alert-{{ type }} {{ cssClass }}"
  role="alert"
  aria-live="polite"
>
  @if (title) {
    <mat-icon
      class="notification-alert__icon"
      [svgIcon]="icon[type]"
      aria-hidden="true"
    />
  }

  <div class="notification-alert__content">
    @if (title) {
      <div class="notification-alert__title" [class.title-bold]="boldTitle">
        {{ title }}
      </div>
    }
    @if (message) {
      <p class="notification-alert__message">{{ message }}</p>
    }
    <div class="content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>

  @if (showCloseButton()) {
    <button
      type="button"
      class="notification-alert__close"
      aria-label="Dismiss alert"
      (click)="dismissed.emit()"
    >
      <mat-icon svgIcon="close" aria-hidden="true" />
    </button>
  }
</div>
